import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useModal } from "../../ModalProvider/ModalProvider";
import SelfManageModalContent from "../SelfManageModalContent/SelfManageModalContent";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

export default function AssignTicketType({ eventId }) {
  const navigate = useNavigate();

  const { closeModal, openModal } = useModal();

  const [ticketType, setTicketType] = useState();
  const [selfManage, setSelfManage] = useState(false);

  const openAssignModal = () => {
    openModal(
      SelfManageModalContent,
      {
        ticketType,
        eventId,
        selfManage,
      },
      { className: "modal-xl", contentClassName: "h-md" },
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    closeModal();
    navigate(`/event/${eventId}/seatmap/assign?type=${ticketType}`);
  };

  const handleClose = () => {
    closeModal();
  };

  const handleChange = (e, checked) => {
    const { name } = e.target;
    if (checked) {
      setTicketType(name);
    }
  };

  return (
    <Modal.Body>
      <div className="modal-body-heading">
        <h1 className="modal-body-heading-title">Assign tickets</h1>
      </div>
      <Form.Label className="mb-0 form-label-sm form-label--lowercase form-label--lowercase-reset">
        Select your ticket type
      </Form.Label>
      <Form.Check
        type="checkbox"
        className="form-check-display mt-4"
        id="ticket-type-checkbox-comp"
      >
        <Form.Check.Input
          name="comp"
          type="checkbox"
          id="ticket-type-checkbox-comp"
          checked={ticketType === "comp"}
          onChange={(e) => {
            handleChange(e, e.target.checked);
          }}
        />
        <div>
          <Form.Check.Label id="ticket-type-checkbox-comp">
            Comp tickets <span className="small text-muted">($0.00)</span>
          </Form.Check.Label>
        </div>
      </Form.Check>
      <Form.Check
        type="checkbox"
        className="form-check-display mt-4"
        id="ticket-type-checkbox-individual"
      >
        <Form.Check.Input
          name="individual"
          type="checkbox"
          id="ticket-type-checkbox-individual"
          checked={ticketType === "individual"}
          onChange={(e) => {
            handleChange(e, e.target.checked);
          }}
        />
        <div>
          <Form.Check.Label id="ticket-type-checkbox-individual">
            Individual tickets{" "}
            <span className="small text-muted">(quantity below 20)</span>
          </Form.Check.Label>
        </div>
      </Form.Check>
      <Form.Check
        type="checkbox"
        className="form-check-display mt-4"
        id="ticket-type-checkbox-group"
      >
        <Form.Check.Input
          name="group"
          type="checkbox"
          id="ticket-type-checkbox-group"
          checked={ticketType === "group"}
          onChange={(e) => {
            handleChange(e, e.target.checked);
          }}
        />
        <div>
          <Form.Check.Label id="ticket-type-checkbox-group">
            Group tickets{" "}
            <span className="small text-muted">(quantity above 20)</span>
          </Form.Check.Label>
        </div>
      </Form.Check>
      {process.env.REACT_APP_STAGE !== "production" && (
        <Form.Check // prettier-ignore
          type="switch"
          id="custom-switch"
          label="Self Managed"
          className="mt-3"
          onChange={(e) => setSelfManage(e.target.checked)}
        />
      )}

      <div className="d-flex btn-group-flex">
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        {!selfManage && (
          <Button
            variant="primary"
            type="submit"
            className="fw-medium px-4"
            disabled={!ticketType}
            onClick={handleSubmit}
          >
            Continue to map
          </Button>
        )}
        {selfManage && (
          <Button
            variant="primary"
            type="submit"
            className="fw-medium px-4"
            disabled={!ticketType}
            onClick={openAssignModal}
          >
            Assign Tickets
          </Button>
        )}
      </div>
    </Modal.Body>
  );
}
